import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, logoTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'summernote/dist/summernote-bs4.min.js'

export default class MonitoringTestsEdit {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');

    // Filter typeaheads
    filterTypeahead('#search_monitoring_rules', 'rules', '/' + accountUrl + '/monitoring/rules?', 132, 'generic');
    filterTypeahead('#search_test_followers', 'users', '/' + accountUrl + '/users?', 95, 'generic');

    // Add portfolio and issuer ids to params for reload
    let reloadParams = function() {
      let params = {};
      let existingRules = $('#testRulesList .remove-rule-from-test');
      let existingFollowers = $('#testFollowersList .remove-follower-from-test');
      let testName = $('#monitoring_test_name').val();
      let testableType = $('.select-record-type:checked').val();
      let testableId = $('#monitoring_test_testable_id').val();
      if (typeof testName !== 'undefined') {params['name'] = testName}
      if (typeof testableType !== 'undefined') {params['testable_type'] = testableType}
      if (typeof testableId !== 'undefined') {params['testable_id'] = testableId}

      // Scroll modal body
      let scrollFilter = $('.modal-body').scrollTop();
      params['sp'] = scrollFilter;

      params['rule_ids'] = [];
      $.each(existingRules, function(i, p) {
        let rid = $(p).attr('data-rule-id');
        let parsedId = parseInt(rid);
        if (!params['rule_ids'].includes(parsedId)) {
          params['rule_ids'].push(parsedId);
        }
      });

      params['follower_ids'] = [];
      $.each(existingFollowers, function(i, p) {
        let fid = $(p).attr('data-user-id');
        let parsedId = parseInt(fid);
        if (!params['follower_ids'].includes(parsedId)) {
          params['follower_ids'].push(parsedId);
        }
      });

      // Return params
      return params;

    }

    // Select record type
    $(".select-record-type").change(function () {

      // Remove testable id (otherwise tries to find Portfolio/Issuer different type with same ID)
      $('#monitoring_test_testable_id').val('');

      // Add by params
      let url = window.location.href.split('?')[0];
      let params = reloadParams();

      // let scrollFilter = $('#reportTemplatesContainer').scrollTop();
      // params['sp'] = scrollFilter;

      Turbo.cache.clear();
      Turbo.visit(url + '?' + $.param(params));

    });

    // On clear
    $('.clear-testable-id-typeahead').click(function() {
      $('#monitoring_test_testable_id').val('');
      $('.default-typeahead').typeahead('val', '');
      $(this).closest('.input-group').find('.default-typeahead').focus();
    })

    // On selecting a rule
    $('#search_monitoring_rules').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $(this).typeahead('val','');
      $(this).blur();
      $('.modal-body').css('opacity', 0.2);
      Spinner($('.modal-content'));

      // Add by params
      let url = window.location.href.split('?')[0];
      let params = reloadParams();
      if (!params['rule_ids'].includes(suggestion.record_id)) {
        params['rule_ids'].push(suggestion.record_id);
      }
      Turbo.visit(url + '?' + $.param(params));

    });

    // On selecting a follower
    $('#search_test_followers').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      $(this).typeahead('val','');
      $(this).blur();
      $('.modal-body').css('opacity', 0.2);
      Spinner($('.modal-content'));

      // Add by params
      let url = window.location.href.split('?')[0];
      let params = reloadParams();
      if (!params['follower_ids'].includes(suggestion.record_id)) {
        params['follower_ids'].push(suggestion.record_id);
      }
      Turbo.visit(url + '?' + $.param(params));

    });

    // Remove test rule
    $('.remove-rule-from-test').off().click(function() {
      let accountUrl = $('body').attr('data-account-url');
      let row = $(this).closest('.test-rule-row');
      let sid = $(this).attr('data-test-rule-id');
      let testId = $(this).attr('data-test-id');
      
      if (sid && testId) {
        // Use AJAX if both IDs are present
        $('.modal-body').css('opacity', 0.2);
        let spinner = "<div class=\'spinner-container d-flex justify-content-center\'>";
        spinner += "<div class=\'spinner-border text-primary\'></div></div>";
        $('.modal-content').append(spinner);
        let url = '/' + accountUrl + '/monitoring/tests/' + testId + '/test_rules/' + sid;
        $.ajax({
          type: 'DELETE',
          url: url,
          complete(result) {
            row.remove();
            $('.modal-body').css('opacity', 1);
            $('.modal-content').find('.spinner-container').remove();
          },
        });
      } else {

        // Remove the row and reload page
        row.remove();
        let url = window.location.href.split('?')[0];
        let params = reloadParams();
        Turbo.visit(url + '?' + $.param(params));

      }
    });

    // Remove test follower
    $('.remove-follower-from-test').off().click(function() {
      let accountUrl = $('body').attr('data-account-url');
      let row = $(this).closest('.test-follower-row');
      let sid = $(this).attr('data-test-follower-id');
      let testId = $(this).attr('data-test-id');
      
      if (sid && testId) {
        // Use AJAX if both IDs are present
        $('.modal-body').css('opacity', 0.2);
        let spinner = "<div class=\'spinner-container d-flex justify-content-center\'>";
        spinner += "<div class=\'spinner-border text-primary\'></div></div>";
        $('.modal-content').append(spinner);
        let url = '/' + accountUrl + '/monitoring/tests/' + testId + '/test_followers/' + sid;
        $.ajax({
          type: 'DELETE',
          url: url,
          complete(result) {
            row.remove();
            $('.modal-body').css('opacity', 1);
            $('.modal-content').find('.spinner-container').remove();
          },
        });
      } else {
        // Remove the row and reload page
        row.remove();
        let url = window.location.href.split('?')[0];
        let params = reloadParams();
        Turbo.visit(url + '?' + $.param(params));
      }
    });


  }
}
